// extracted by mini-css-extract-plugin
export var background = "hero-module--background--dc2d5";
export var content = "hero-module--content--7dd31";
export var hero = "hero-module--hero--fd186";
export var isFullDesktop = "hero-module--isFullDesktop--b85e8";
export var isFullMobile = "hero-module--isFullMobile--13db4";